import {SVGProps} from 'react';

function BaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden focusable="false" {...props}>
      {props.children}
    </svg>
  );
}

export function BoldToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 3.5h4.2c1.9 0 3 1 3 2.5 0 1-.5 1.8-1.4 2.2 1.2.4 1.9 1.3 1.9 2.6 0 1.8-1.3 3.2-3.7 3.2H4V3.5Zm1.7 4.2h2.3c1 0 1.6-.5 1.6-1.3 0-.8-.6-1.3-1.6-1.3H5.7v2.6Zm0 4.8h2.7c1.1 0 1.8-.6 1.8-1.5s-.7-1.5-1.8-1.5H5.7v3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function ItalicToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M5.5 3h6v1.5H9.3l-2.6 7h2.3V13h-6v-1.5h2.2l2.6-7H5.5V3Z" fill="currentColor" />
    </BaseIcon>
  );
}

export function UnderlineToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 3v4.7C5 9 6.1 10 7.9 10c1.8 0 3.1-1 3.1-2.3V3h1.7v4.8c0 2.2-1.9 3.8-4.8 3.8-2.8 0-4.6-1.6-4.6-3.8V3H5Z"
        fill="currentColor"
      />
      <path d="M3 13h10v1.5H3z" fill="currentColor" />
    </BaseIcon>
  );
}

export function StrikethroughToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M3 7h10v1.5H3z" fill="currentColor" />
      <path
        d="M8.1 3c2 0 3.3.7 4.2 1.8l-1.2 1c-.7-.8-1.7-1.3-3.1-1.3-1.4 0-2.2.5-2.2 1.3 0 .7.6 1 2.8 1.4l.7.1c2.5.4 3.6 1.2 3.6 2.9 0 2-1.8 3.3-4.6 3.3-2.3 0-4-.8-5-2.2l1.2-1c.9 1.1 2.1 1.7 3.8 1.7 1.6 0 2.7-.5 2.7-1.5 0-.8-.6-1.1-2.5-1.4l-.7-.1C4.7 8.6 4 7.8 4 6.1 4 4.2 5.7 3 8.1 3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function UnorderedListToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <circle cx="3" cy="4" r="1" fill="currentColor" />
      <circle cx="3" cy="8" r="1" fill="currentColor" />
      <circle cx="3" cy="12" r="1" fill="currentColor" />
      <path d="M6 3.25h7v1.5H6zm0 4h7v1.5H6zm0 4h7v1.5H6z" fill="currentColor" />
    </BaseIcon>
  );
}

export function OrderedListToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      {/* Line 1 number */}
      <path d="M2.5 2.5h.9v3.25h-.9V3.75H1.75V3H2.5V2.5Z" fill="currentColor" />
      {/* Line 2 number */}
      <path
        d="M1.5 8.1C1.5 7.2 2.1 6.5 3 6.5c.9 0 1.5.6 1.5 1.3 0 .5-.25.9-.7 1.3L2.6 10.1H4.5V11H1.5v-.7l1.6-1.45c.4-.35.55-.6.55-.9 0-.3-.25-.55-.65-.55s-.7.3-.7.75H1.5Zm.15 4.15h2.7v.75H1.65v-.65l1.7-1.6H1.65v-.75h2.65v.65l-1.7 1.6Z"
        fill="currentColor"
      />
      {/* Three horizontal lines (text rows) */}
      <path d="M6 3.25h7v1.5H6zm0 4h7v1.5H6zm0 4h7v1.5H6z" fill="currentColor" />
    </BaseIcon>
  );
}

export function AlignLeftToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M3 3h10v1.5H3zm0 3h7v1.5H3zm0 3h10v1.5H3zm0 3h7v1.5H3z" fill="currentColor" />
    </BaseIcon>
  );
}

export function AlignCenterToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M3 3h10v1.5H3zm2 3h6v1.5H5zm-2 3h10v1.5H3zm2 3h6v1.5H5z" fill="currentColor" />
    </BaseIcon>
  );
}

export function AlignRightToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M3 3h10v1.5H3zm3 3h7v1.5H6zm-3 3h10v1.5H3zm3 3h7v1.5H6z" fill="currentColor" />
    </BaseIcon>
  );
}

export function AlignJustifyToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <path d="M3 3h10v1.5H3zm0 3h10v1.5H3zm0 3h10v1.5H3zm0 3h10v1.5H3z" fill="currentColor" />
    </BaseIcon>
  );
}

export function EmojiToolbarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <BaseIcon {...props}>
      <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.4" fill="none" />
      <circle cx="6" cy="6.5" r="0.8" fill="currentColor" />
      <circle cx="10" cy="6.5" r="0.8" fill="currentColor" />
      <path
        d="M5.2 9.4c.6 1.1 1.6 1.7 2.8 1.7 1.2 0 2.2-.6 2.8-1.7"
        stroke="currentColor"
        strokeWidth="1.4"
        fill="none"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
}
